import axios from "axios";
import React, { useState } from "react";

import { useAuthContext } from "../../../hooks/useAuthContext";
import { ApiConnectionString } from "../../../constants/ApiConntection";
import LoadingSpinner from "../../../components/LoadingSpinner";


export default function ConfirmDeleteProfile({ profile, cancelModal,fetchData }) {
  const [complete, setComplete] = useState(false);
  const { user } = useAuthContext();
  const [isLoading, setIsLoading] = useState(false);
//styled

const handleDelete = async () => {
  setIsLoading(true);
  try {
    const deleteResponse = await axios.delete(
      `${ApiConnectionString}/api/BookingProfile/${profile.id}`,
      {
        headers: { Authorization: `Bearer ${user.token}` },
      }
    );

    if (deleteResponse.status === 200) {
      setComplete(true); // Indicate successful deletion
    }
  } catch (error) {
    console.error("Error deleting booking profile:", error);
    // Optionally add user-facing error handling (e.g., show an alert)
  } finally {
    setIsLoading(false); // Reset the loading state
  }
};

if (isLoading) {
  return (
    <div className="send-modal-overlay">
      <div className="send-modal">
        <LoadingSpinner />
      </div>
    </div>
  );
}
else{



  if (complete) {
    return (
      <div className="send-modal-overlay">
        <div className="send-modal">
        <div className='blueBanner'><p className='fw-bold m-2 p-2 fontSize20'>Profile Deleted</p></div> 
        <p>Are you sure you want to delete this profile?</p>

          <div className="send-modal-footer">
         
            <button  className="pointer cancelButton fw-bold mx-2 px-3" onClick={() => {cancelModal(); fetchData();}}>
              Okay
            </button>
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div className="send-modal-overlay">
        <div className="send-modal">
        <div className='blueBanner'><p className='fw-bold m-2 p-2 fontSize20'>Delete Profile</p></div> 

<button
             type="button"
             className="close-button"
             onClick={cancelModal}
             aria-label="Close"
           >
             &times;
           </button>
         
           <table>
  <tbody>
    <tr>
      <td className="red-text"><strong>Name:</strong></td>
      <td>{profile.firstName} {profile.lastName}</td>
    </tr>
    <tr>
      <td className="red-text"><strong>Username:</strong></td>
      <td>{profile.username}</td>
    </tr>
  </tbody>
</table>

<p>Are you sure you want to delete this profile?</p>


          <div className="send-modal-footer">
            <button className="saveChanges-button mx-3" onClick={handleDelete}>
              Confirm
            </button>
            <button
                  onClick={cancelModal}
                  className="pointer cancelButton fw-bold mx-2 px-3"
                >
                  Cancel
                </button>
          </div>
        </div>
      </div>
    );
  }
}
}